import { useCallback, useEffect, useRef } from "react";

interface UseTrafficLayerProps {
  map: google.maps.Map | null;
  showTraffic: boolean;
}

export const useTrafficLayer = ({ map, showTraffic }: UseTrafficLayerProps) => {
  const trafficLayerRef = useRef<google.maps.TrafficLayer | null>(null);

  useEffect(() => {
    if (!map) return;

    if (showTraffic) {
      if (!trafficLayerRef.current) {
        trafficLayerRef.current = new google.maps.TrafficLayer();
      }
      trafficLayerRef.current.setMap(map);
    } else {
      if (trafficLayerRef.current) {
        trafficLayerRef.current.setMap(null);
      }
    }

    return () => {
      if (trafficLayerRef.current) {
        trafficLayerRef.current.setMap(null);
      }
    };
  }, [map, showTraffic]);

  const toggleTraffic = useCallback(() => {
    if (!map || !trafficLayerRef.current) return;

    if (showTraffic) {
      trafficLayerRef.current.setMap(null);
    } else {
      trafficLayerRef.current.setMap(map);
    }
  }, [map, showTraffic]);

  return {
    toggleTraffic,
  };
};
